import axios from 'axios';
import '../services/interceptors';
// LOCAL
axios.defaults.baseURL = process.env.REACT_APP_URL;
//PROD
// axios.defaults.baseURL = 'http://bk-jus-labore-dev.us-east-1.elasticbeanstalk.com';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

export default axios;
